import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@amazing-care/ui/empty";
import { LockIcon } from "lucide-react";

export function RestrictedAccess() {
  return (
    <Empty className="min-h-64">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <LockIcon />
        </EmptyMedia>
        <EmptyTitle>You don't have access to this page</EmptyTitle>
        <EmptyDescription>
          Administration is limited to admin accounts. Ask an administrator if you need access.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
